document.querySelectorAll('a[href*="#"]:not([href="#"])').forEach(link => {
    link.addEventListener('click', function (e) {
        const targetId = this.getAttribute('href').split('#')[1];
        const targetEl = document.getElementById(targetId);

        if (targetEl) {
            e.preventDefault();

            const header = document.querySelector('.header');
            const headerHeight = header ? header.offsetHeight : 0;
            const elementPosition = targetEl.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerHeight;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        }
    });
});